/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { getBillingHistory, fetchBillingHistoryRequest } from '@/reducers/billing'
import { fetchBillingHistory } from '@/actions/billing'
import {
  getPaymentDetails,
  getPaymentDetailsRequest,
} from '@/apps/userconsole/actions/billing/paymentDetails'

import BillingHistory from './BillingHistory'

import type { GetPaymentDetails } from '@/apps/userconsole/actions/billing/paymentDetails'
import type { ThunkDispatch } from '@/types/redux'
import type { ConsumerProps, DispatchProps } from './types'

const mapStateToProps = (state, { profile }: ConsumerProps) => ({
  billingHistory: profile && getBillingHistory(state, profile.organization_id!),
  fetchBillingHistoryRequest: fetchBillingHistoryRequest(state),
  getPaymentDetailsRequest: getPaymentDetailsRequest(state),
})

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  fetchBillingHistory: (params) => dispatch(fetchBillingHistory(params)),
  getPaymentDetails: (props: GetPaymentDetails) => dispatch(getPaymentDetails(props)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BillingHistory)
